import { Routes } from '@angular/router';
import { AuthGuard, NotAuthGuard } from './core/middleware/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'error',
    loadChildren: () => import('./core/layouts/errors.routing').then(m => m.ERROR_ROUTES),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./core/layouts/layout.routing').then(m => m.LAYOUT_ROUTES),
  },
  {
    path: 'auth',
    canActivate: [NotAuthGuard],
    loadChildren: () => import('./core/layouts/auth.routing').then(m => m.AUTH_ROUTES),
  },

  { path: '**', redirectTo: 'error/404' },
];
